<template>
  <div v-show="showBanner">
    <transition appear leave name="fade">
      <div ref="container" class="mb-8"></div>
    </transition>
    <p ref="myParagraph" class="text-center hidden">
      <button
        ref="myButton"
        @click="triggerFilterClick"
        class="btn btn-md btn-primary"
      >
        {{ translations.ViewObjectives }}
      </button>
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// Define constants for selectors.
const BANNER_SELECTOR = '.t3m-ObjectiveFinder-banner'
const FILTER_SELECTOR =
  '[data-filter-item-id="t3m-ObjectiveFinder-filter-input--shop"]'

export default {
  name: 'Banner',
  mounted() {
    // Use the constant to get the banner element.
    const banner = document.querySelector(BANNER_SELECTOR)
    if (banner) {
      // Teleport the banner element into the container.
      this.$refs.container.appendChild(banner)

      // Get the entire paragraph element (with the button).
      const paragraph = this.$refs.myParagraph

      // Find all <p> elements inside the banner.
      const pElements = banner.getElementsByTagName('p')
      if (pElements.length > 0) {
        // Insert the paragraph after the last <p>.
        const lastP = pElements[pElements.length - 1]
        lastP.insertAdjacentElement('afterend', paragraph)
      } else {
        // If no <p> is found, append the paragraph at the end.
        banner.appendChild(paragraph)
      }
    }
  },
  methods: {
    triggerFilterClick() {
      // Use the constant FILTER_SELECTOR to find the filter input element.
      const inputEl = document.querySelector(FILTER_SELECTOR)
      if (inputEl && !inputEl.checked) {
        inputEl.click()
      }
      // Use the store to hide the banner
      this.$store.dispatch('setShowBanner', false)
    },
  },
  computed: {
    ...mapState(['translations', 'shopEnabled', 'showBanner']),
  },
}
</script>
